import { Component, ChangeDetectionStrategy } from '@angular/core';
import { INotificacao } from '@interfaces/notificacao';
import { NotificacoesService } from '@services/notificacoes.service';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: '[app-notificacoes-dropdown]',
    templateUrl: './notificacoes-dropdown.component.html',
    styleUrls: ['./notificacoes-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, AsyncPipe]
})
export class NotificacoesDropdownComponent {

  constructor(public notificacoesService: NotificacoesService) { }

  dismissNotification(item: INotificacao) {
    this.notificacoesService.remover(item.id);
  }

  clearNotifications() {
    this.notificacoesService.limpar();
  }

}
